<div class="flex justify-between items-center gap-2 w-full">
  <div class="flex gap-2 flex-grow flex-wrap sm:flex-nowrap">
    <div class="w-[200px] min-w-[200px]">
      <form>
        <mat-form-field class="w-full" appearance="outline" [subscriptSizing]="'dynamic'">
          <mat-select [formControl]="filterSelect" [placeholder]="'COMMON.PLACEHOLDER.SELECT' | transloco">
            @for (option of filtersOptions; track option) {
              <mat-option [value]="option.property">
                {{ option.label | transloco }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </form>
    </div>
    @if (filterSelect.value) {
      <div class="flex-grow">
        @switch (_config.filters[filterSelect.value].type) {
          @case (eAdvancedFilterType.DATE) {
            <aup-advanced-filters-date
              [filterDefinition]="_config.filters[filterSelect.value]"
              [filterData]="filter"
              [apiCallStateKey]="_config.apiCallStateKey"
              [displayValidationErrors]="_displayValidationErrors!"
              [fiscalYear]="_config.fiscalYear"
            ></aup-advanced-filters-date>
          }
          @case (eAdvancedFilterType.NUMBER) {
            <aup-advanced-filters-number
              [filterDefinition]="_config.filters[filterSelect.value]"
              [filterData]="filter"
              [apiCallStateKey]="_config.apiCallStateKey"
              [displayValidationErrors]="_displayValidationErrors!"
            ></aup-advanced-filters-number>
          }
          @case (eAdvancedFilterType.SELECT) {
            <aup-advanced-filters-select
              [filterDefinition]="_config.filters[filterSelect.value]"
              [filterData]="filter"
              [apiCallStateKey]="_config.apiCallStateKey"
              [displayValidationErrors]="_displayValidationErrors!"
            ></aup-advanced-filters-select>
          }
          @case (eAdvancedFilterType.STATUS) {
            <aup-advanced-filters-status
              [filterDefinition]="_config.filters[filterSelect.value]"
              [filterData]="filter"
              [apiCallStateKey]="_config.apiCallStateKey"
              [displayValidationErrors]="_displayValidationErrors!"
            ></aup-advanced-filters-status>
          }
          @case (eAdvancedFilterType.TEXT) {
            <aup-advanced-filters-text
              [filterDefinition]="_config.filters[filterSelect.value]"
              [filterData]="filter"
              [apiCallStateKey]="_config.apiCallStateKey"
              [displayValidationErrors]="_displayValidationErrors!"
            ></aup-advanced-filters-text>
          }
        }
      </div>
    }
  </div>
  <div class="w-[50px]">
    <button mat-icon-button [class.!hidden]="isLast && !filterSelect.value" (click)="onFilterDelete()">
      <mat-icon svgIcon="delete"></mat-icon>
    </button>
  </div>
</div>
